import { UserInfo } from '../../api/dtos/user/UserProfile';
import { AUTH_DEFINE_PASSWORD, AUTH_LOGIN, AUTH_LOGOUT, AuthActionTypes } from './types';

export interface AuthState {
    user: UserInfo | null;
    token: string | null;
    isAuthenticated: boolean;
    expirationDate: number;
    refreshToken: string | null;
}

const initialState: AuthState = {
    user: null,
    token: null,
    isAuthenticated: false,
    expirationDate: 0,
    refreshToken: null
};

export default function AuthReducer(state = initialState, action: AuthActionTypes): AuthState {
    switch (action.type) {
        case AUTH_LOGIN:
            return {
                ...state,
                user: action.user,
                token: action.accessToken,
                isAuthenticated: true,
                expirationDate: action.expirationDate,
                refreshToken: action.refreshToken,
            };
        case AUTH_LOGOUT:
            return {
                ...state,
                user: null,
                token: null,
                isAuthenticated: false,
                refreshToken: null,
            };
        case AUTH_DEFINE_PASSWORD:
            return {
                ...state,
                user: state.user ? { ...state.user } : null,
            };
        default:
            return state;
    }
}
